import React, { useEffect, useRef } from "react"
import Moment from "react-moment"
import styled from "styled-components"
import ProductCard from "./ProductCard";
// import '../App.css'

const Message = ({ msg , user1}) => {

    const scrollRef = useRef();

    useEffect(() => {
      scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [msg]);
  return (
    <MessageWrapper
    className={`message_wrapper ${msg.from === user1 ? "own" : ""}`}
    ref={scrollRef}
  >
    {
      msg.enqProduct?.productPhoto &&
      // <img src={msg.productImg} alt="" />
      <>
         <img
        style={{ width: "100px" }}
        className="productImage"
        src={msg.enqProduct?.productPhoto}
        alt=""
      />
      <div>{`$ ${msg.enqProduct?.productDetails?.discountedPrice}`}</div>
      <div>{`${msg.enqProduct?.productDetails?.productName}`}</div>
      </>
    }
    {
      msg.enqProduct?.productPhoto?
      <small className="timing">
        <Moment fromNow>{msg.createdAt.toDate()}</Moment>
      </small>
    :
    <p className={msg.from === user1 ? "me" : "friend"}>
      {msg.textMessage}
      <br />
      <small className="timing">
        <Moment fromNow>{msg.createdAt.toDate()}</Moment>
      </small>
    </p>
    }
    </MessageWrapper>
  )
}

export default Message

const MessageWrapper = styled.div`
  .message_wrapper {
  margin-top: 5px;
  padding: 0px 5px;
}
.message_wrapper img {
  width: 100%;
  border-radius: 5px;
}
.message_wrapper p {
  padding: 10px;
  display: inline-block;
  max-width: 50%;
  text-align: left;
  border-radius: 5px;
  color: ${({theme}) => theme.text};
}
.timing  {
  display: inline-block;
  margin-top: 15px;
  opacity: 0.8;
  color: ${({theme}) => theme.text};
}
.message_wrapper.own {
  text-align: right;
}
.me {
  background:  ${({theme}) => theme.background};
  color: ${({theme}) => theme.text};
}
.friend {
  background:  ${({theme}) => theme.accent};
  color: ${({theme}) => theme.text};
}

.truncate {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`